/* Ulka Rocks chat concierge widget.
   Stateless backend: full history is sent each turn and streamed back as SSE.
   Config comes from window.URChatConfig (set in snippets/ur-chat-widget.liquid). */
(function () {
  'use strict';

  var cfg = window.URChatConfig || {};
  var ENDPOINT = cfg.endpoint;
  if (!ENDPOINT) return;

  var PHONE = cfg.phone || '+18323875129';
  var PHONE_DISPLAY = cfg.phoneDisplay || '(832) 387-5129';
  var EMAIL = cfg.email || 'ulka@ulkarocks.com';

  // Personalized welcome for logged-in shoppers; names the tier for VIPs (once).
  var GREETING;
  if (cfg.customer && cfg.customer.firstName) {
    var nm = cfg.customer.firstName;
    if (cfg.customer.isVip && cfg.customer.vipTier) {
      GREETING =
        'Welcome back, ' + nm + '! 💖 Always a treat to have one of our ' +
        cfg.customer.vipTier + 's here. What can I help you find today?';
    } else {
      GREETING = "Welcome back, " + nm + "! 😊 So glad you're here. What can I help you find today?";
    }
  } else {
    GREETING =
      cfg.greeting ||
      "Welcome to Ulka Rocks! So glad you're here. Who am I chatting with? 😊";
  }
  var STORAGE_KEY = 'ur-chat-history-v2';
  var LOG_KEY = 'ur-chat-log-id-v2';
  var history = [];
  var busy = false;
  var logId = null;
  var visitorName = '';
  try {
    logId = sessionStorage.getItem(LOG_KEY) || null;
  } catch (e) {
    logId = null;
  }

  try {
    history = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
  } catch (e) {
    history = [];
  }

  /* ---------- DOM ---------- */
  var launcher = document.createElement('button');
  launcher.className = 'ur-chat-launcher';
  launcher.type = 'button';
  launcher.setAttribute('aria-label', 'Open chat with the Ulka Rocks AI Concierge');
  if (cfg.icon) {
    launcher.classList.add('ur-chat-launcher--image');
    var launcherImg = document.createElement('img');
    launcherImg.src = cfg.icon;
    launcherImg.alt = '';
    launcher.appendChild(launcherImg);
  } else {
    launcher.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3C6.5 3 2 6.9 2 11.7c0 2.7 1.4 5.1 3.7 6.7-.2.8-.7 2.1-1.6 3.1-.2.2 0 .5.2.5 2 0 3.7-1 4.7-1.8 1 .2 2 .4 3 .4 5.5 0 10-3.9 10-8.9S17.5 3 12 3z"/></svg>';
  }

  var panel = document.createElement('section');
  panel.className = 'ur-chat-panel';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-label', 'Ulka Rocks AI Concierge chat');
  var avatarHtml = cfg.icon
    ? '<img class="ur-chat-avatar" src="' + encodeURI(cfg.icon) + '" alt="">'
    : '';
  panel.innerHTML =
    '<header class="ur-chat-header">' +
    avatarHtml +
    '<div class="ur-chat-header-text"><h2>Ulka Rocks AI Concierge</h2>' +
    '<p>Prefer Ulka? <a class="ur-chat-header-contact" href="mailto:' + EMAIL + '">Contact her directly</a></p></div>' +
    '<button type="button" class="ur-chat-close" aria-label="Close chat">&times;</button>' +
    '</header>' +
    '<button type="button" class="ur-chat-insider-cta">' +
    '<span class="ur-chat-insider-spark" aria-hidden="true">&#10024;</span> Become an Ulka Rocks Insider' +
    '</button>' +
    '<div class="ur-chat-messages" aria-live="polite"></div>' +
    '<form class="ur-chat-form">' +
    '<textarea class="ur-chat-input" rows="1" maxlength="1000" placeholder="Ask about a stone, a piece, a show..." aria-label="Your message"></textarea>' +
    '<button type="submit" class="ur-chat-send" aria-label="Send message">' +
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 21l21-9L2 3v7l15 2-15 2v7z"/></svg>' +
    '</button></form>' +
    '<p class="ur-chat-disclaimer">Built by <a class="ur-chat-credit" href="https://automationedit.ai" target="_blank" rel="noopener">AutomationEdit</a> (Ulka\'s AI company)</p>';

  document.body.appendChild(launcher);
  document.body.appendChild(panel);

  var msgBox = panel.querySelector('.ur-chat-messages');
  var form = panel.querySelector('.ur-chat-form');
  var input = panel.querySelector('.ur-chat-input');
  var sendBtn = panel.querySelector('.ur-chat-send');
  var closeBtn = panel.querySelector('.ur-chat-close');
  var headerContact = panel.querySelector('.ur-chat-header-contact');
  var insiderCta = panel.querySelector('.ur-chat-insider-cta');

  // One-click entry into the insider-list flow: drops a primed message so the
  // concierge pitches the list in Ulka's voice and asks for the email. The
  // existing capture_lead tool handles the actual Klaviyo subscribe + logging.
  insiderCta.addEventListener('click', function () {
    if (busy) return;
    insiderCta.setAttribute('hidden', '');
    if (!panel.classList.contains('is-open')) openPanel();
    send("I'd love to join the Ulka Rocks insider list.");
  });

  // Do not pitch "Become an Insider" to people already in: a Collector's Circle member (any
  // tier) OR an email subscriber (accepts marketing, which Klaviyo syncs to
  // Shopify). Keep it for logged-out visitors and not-yet-subscribed shoppers.
  if (
    cfg.customer &&
    ((cfg.customer.vipTier && cfg.customer.vipTier !== '-') || cfg.customer.acceptsMarketing)
  ) {
    insiderCta.setAttribute('hidden', '');
  }

  // What page is the visitor on? Goes into the text/email so Ulka has context.
  function pageContext() {
    var title = (document.title || 'Ulka Rocks').replace(/\s*[-|–]\s*Ulka Rocks.*$/i, '').trim();
    return { title: title || 'Ulka Rocks', url: location.href };
  }

  // Phones get a native text; everything else (iPad, tablets, desktops) gets
  // email. iPad Safari reports a Mac user agent, so only phone tokens count.
  var IS_PHONE = /iPhone|iPod|Android.*Mobile/i.test(navigator.userAgent);

  // Build the contact href fresh each open and click so it carries the current
  // page and the visitor's first name if the concierge captured it.
  function setContactHref(href) {
    headerContact.setAttribute('href', href);
  }
  function refreshContactLinks() {
    var ctx = pageContext();
    var who = visitorName ? 'This is ' + visitorName + '. ' : '';
    var smsBody =
      'Hi Ulka! ' +
      who +
      'I have a question from my chat with your concierge. The page I am on: ' +
      ctx.url +
      '. Here is my question: ';
    if (IS_PHONE) {
      setContactHref('sms:' + PHONE + '?&body=' + encodeURIComponent(smsBody));
      return;
    }

    var subject = 'Question from your website concierge chat';
    var emailBody =
      'Hi Ulka,\n\n' +
      who +
      'I have a question from the chat I started with your concierge.\n\nThe page I am on: ' +
      ctx.url +
      '\n\nHere is my question: ';
    setContactHref(
      'mailto:' + EMAIL + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(emailBody)
    );
  }

  refreshContactLinks();
  // No preventDefault: the anchor's own href opens Messages or Mail.
  headerContact.addEventListener('click', refreshContactLinks);

  /* ---------- rendering ---------- */
  function escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // Brand rule: no em dashes anywhere, ever. Hard scrub regardless of model output.
  function scrubText(text) {
    return text.replace(/\s*—\s*/g, ', ');
  }

  // Minimal safe markdown: **bold** + allowlisted links (markdown or bare URL).
  // Domain must end at a /, ?, # or a word boundary — otherwise
  // ulkarocks.com.evil.com or ulkarocks.com@evil.com would slip through.
  var LINK_MD_RE = /\[([^\]]+)\]\((https:\/\/(?:www\.)?(?:ulkarocks\.com|instagram\.com\/ulkarocks)(?:[/?#][^\s)]*)?)\)/g;
  var LINK_BARE_RE = /https:\/\/(?:www\.)?(?:ulkarocks\.com|instagram\.com\/ulkarocks)(?![\w.@-])(?:[/?#][^\s<]*)?/g;

  function renderMarkdown(text) {
    var html = escapeHtml(scrubText(text));
    // Finished anchors are stashed behind \x00 tokens so later passes can't rematch them.
    var anchors = [];
    function stash(anchor) {
      anchors.push(anchor);
      return '\x00' + (anchors.length - 1) + '\x00';
    }
    html = html.replace(LINK_MD_RE, function (m, label, url) {
      return stash('<a href="' + url + '">' + label + '</a>');
    });
    // Any other markdown link degrades to its text — never render off-brand URLs.
    html = html.replace(/\[([^\]]+)\]\([^\s)]*\)/g, '$1');
    // The model sometimes emits bare URLs instead of markdown; those must be clickable too.
    html = html.replace(LINK_BARE_RE, function (url) {
      var trail = (url.match(/[.,!?;:)]+$/) || [''])[0];
      if (trail) url = url.slice(0, -trail.length);
      return stash('<a href="' + url + '">' + url + '</a>') + trail;
    });
    html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    return html.replace(/\x00(\d+)\x00/g, function (m, i) {
      return anchors[+i];
    });
  }

  function addMsg(role, text) {
    var div = document.createElement('div');
    div.className = 'ur-chat-msg ur-chat-msg--' + (role === 'user' ? 'user' : 'bot');
    if (role === 'user') {
      div.textContent = text;
    } else {
      div.innerHTML = renderMarkdown(text);
    }
    msgBox.appendChild(div);
    msgBox.scrollTop = msgBox.scrollHeight;
    return div;
  }

  function setStatus(text) {
    clearStatus();
    var div = document.createElement('div');
    div.className = 'ur-chat-status';
    div.textContent = text;
    msgBox.appendChild(div);
    msgBox.scrollTop = msgBox.scrollHeight;
  }
  function clearStatus() {
    var s = msgBox.querySelector('.ur-chat-status');
    if (s) s.remove();
  }

  function save() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(history.slice(-30)));
    } catch (e) {
      /* storage full or blocked: chat still works, history just won't persist */
    }
  }

  function restore() {
    msgBox.innerHTML = '';
    addMsg('assistant', GREETING);
    history.forEach(function (m) {
      addMsg(m.role, m.content);
    });
  }

  /* ---------- open / close ---------- */
  function openPanel() {
    panel.classList.add('is-open');
    refreshContactLinks();
    if (!msgBox.children.length) restore();
    input.focus();
  }
  function closePanel() {
    panel.classList.remove('is-open');
    launcher.focus();
  }
  launcher.addEventListener('click', function () {
    panel.classList.contains('is-open') ? closePanel() : openPanel();
  });
  closeBtn.addEventListener('click', closePanel);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
  });

  /* ---------- programmatic open (product-page CTAs) ----------
     Any element with data-ur-concierge opens the chat, clean and empty.
     The bot learns which piece the visitor is on from the `page` field the
     widget already sends with every request (never shown in the chat). If
     this script fails to load, the element's own href (sms:) is the fallback. */
  window.URChat = {
    open: function () {
      openPanel();
      input.focus();
    }
  };
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-ur-concierge]') : null;
    if (!el) return;
    e.preventDefault();
    window.URChat.open();
  });

  /* ---------- send ---------- */
  var STATUS_LABELS = {
    search_products: 'Hunting the collection for you 💎',
    capture_lead: 'Adding you to the insider list ✨',
  };
  // Simple, friendly "working" lines in Ulka's voice; rotates so it feels alive.
  var THINKING = [
    'Hunting... 💎',
    'Checking... ✨',
    'Working... 💖',
    'On it 😊',
    'Lusterizing... ✨',
    'Glimmerizing... 💙',
    'Gemifying... 💎',
    'Jewelryfying... 🎉',
  ];
  var thinkingIdx = 0;
  function thinkingLabel() {
    var s = THINKING[thinkingIdx % THINKING.length];
    thinkingIdx++;
    return s;
  }

  function send(text) {
    if (busy || !text.trim()) return;
    busy = true;
    sendBtn.disabled = true;

    addMsg('user', text);
    history.push({ role: 'user', content: text });
    save();
    setStatus(thinkingLabel());

    var botDiv = null;
    var botText = '';

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        messages: history,
        log_id: logId || undefined,
        page: { title: document.title, url: location.href },
        customer: cfg.customer || undefined,
      }),
    })
      .then(function (res) {
        if (!res.ok || !res.body) throw new Error('HTTP ' + res.status);
        var reader = res.body.getReader();
        var decoder = new TextDecoder();
        var buffer = '';

        function pump() {
          return reader.read().then(function (r) {
            if (r.done) return finish();
            buffer += decoder.decode(r.value, { stream: true });
            var lines = buffer.split('\n\n');
            buffer = lines.pop();
            lines.forEach(function (line) {
              if (line.indexOf('data: ') !== 0) return;
              var evt;
              try {
                evt = JSON.parse(line.slice(6));
              } catch (e) {
                return;
              }
              if (evt.type === 'text') {
                clearStatus();
                if (!botDiv) botDiv = addMsg('assistant', '');
                botText += evt.text;
                botDiv.innerHTML = renderMarkdown(botText);
                msgBox.scrollTop = msgBox.scrollHeight;
              } else if (evt.type === 'done') {
                if (evt.visitor_name) visitorName = evt.visitor_name;
                if (evt.log_id) {
                  logId = evt.log_id;
                  try {
                    sessionStorage.setItem(LOG_KEY, logId);
                  } catch (e) {
                    /* persistence is best-effort */
                  }
                }
              } else if (evt.type === 'status') {
                setStatus(STATUS_LABELS[evt.tool] || thinkingLabel());
              } else if (evt.type === 'error') {
                clearStatus();
                botText = evt.text;
                if (!botDiv) botDiv = addMsg('assistant', '');
                botDiv.innerHTML = renderMarkdown(botText);
              }
            });
            return pump();
          });
        }
        return pump();
      })
      .catch(function () {
        clearStatus();
        if (!botText) {
          botText = 'I could not connect just now. Please try again, or text Ulka at (832) 387-5129.';
          addMsg('assistant', botText);
        }
        finish();
      });

    function finish() {
      clearStatus();
      if (botText) {
        history.push({ role: 'assistant', content: scrubText(botText) });
        save();
      }
      busy = false;
      sendBtn.disabled = false;
      input.focus();
    }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = input.value;
    input.value = '';
    send(text);
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      form.dispatchEvent(new Event('submit'));
    }
  });
})();

